import styled, { StyledComponent } from 'styled-components';
import theme from '@config/theme';
import { ITypeStyle } from './types';
import { FlexRow } from '@ui/Containers/FlexContainer';

const typeElements = {
  h1: styled.h1<ITypeStyle>``,
  h2: styled.h2<ITypeStyle>``,
  h3: styled.h3<ITypeStyle>``,
  h4: styled.h4<ITypeStyle>``,
  h6: styled.h6<ITypeStyle>``,
  body: styled.p<ITypeStyle>``,
  caption: styled.p<ITypeStyle>``,
};

const Typography = (variant: string): StyledComponent<any, any> => {
  // @ts-ignore
  const Element = typeElements[variant];
  // @ts-ignore
  const typeStyle = theme.typography[variant];

  return styled(Element)`
    font-family: ${(props) => props.fontFamily || typeStyle.fontFamily};  
    font-size: ${(props) => props.fontSize || typeStyle.size.xSmall};
    font-style: ${(props) => props.variant || 'normal'};
    font-weight: ${(props) => props.fontWeight || typeStyle.fontWeight};
    line-height: ${(props) => props.lineHeight || typeStyle.lineHeight};  
    
    @media ${theme.device.tablet} {
      font-size: ${(props) => props.fontSize || typeStyle.size.small};
    }
    
    @media ${theme.device.laptop} {
      font-size: ${(props) => props.fontSize || typeStyle.size.medium};
    }
    
    @media ${theme.device.laptopL} {
      font-size: ${(props) => props.fontSize || typeStyle.size.large};
    }
  `;
};

const H1 = Typography('h1');
const H2 = Typography('h2');
const H3 = Typography('h3');
const H4 = Typography('h4');
const H6 = Typography('h6');
const Body = Typography('body');
const Caption = Typography('caption');

export const PageTitle = styled(H1)`
  font-size: 24px;
  font-weight: 700;
  color: ${theme.palette.primary.hue};
  margin: 0;
`;

export const PageSubtitle = styled(FlexRow)`
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  min-height: 40px;
  background-color: ${theme.palette.primary.hue};
  color: ${theme.palette.primary.contrastText};
  padding: 4px 12px;
  margin-left: auto;
  border-radius: 4px 0 0 4px;
  & div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  @media ${theme.device.laptop} {
    font-size: 14px;
    letter-spacing: 0.2em;
  }
`;

export {
  H1,
  H2,
  H3,
  H4,
  H6,
  Body,
  Caption,
};
